import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Check, Circle, AlertTriangle } from 'lucide-react'
import { Panel, Chip, Button } from '../ds/index'
import { Icon } from './Icon'
import { useApi } from '../lib/useApi'

type Item = { key: string; title: string; status: 'done' | 'todo' | 'warn'; detail: string; link: string; owner: string }

/** What still stands between this install and real leads. Gone once everything is done. */
export function LaunchChecklist() {
  const { data } = useApi<{ items: Item[]; done: number; total: number }>('/api/launch')
  const [all, setAll] = useState(false)
  if (!data || data.done === data.total) return null
  const open = data.items.filter((i) => i.status !== 'done')
  const shown = all ? data.items : open
  return (
    <Panel>
      <div className="panel-header">
        <h2 className="panel-title">Launch checklist</h2>
        <span className="muted">{data.done} of {data.total} ready</span>
      </div>
      <span className="stat-bar launch-bar"><i style={{ width: `${(data.done / data.total) * 100}%` }} /></span>
      <ul className="launch-list">
        {shown.map((i) => (
          <li key={i.key} className={`launch-${i.status}`}>
            <span className="launch-icon"><Icon of={i.status === 'done' ? Check : i.status === 'warn' ? AlertTriangle : Circle} /></span>
            <span className="launch-text">
              <Link to={i.link}><strong>{i.title}</strong></Link>
              <span className="muted">{i.detail}</span>
            </span>
            {i.status !== 'done' && <Chip>{i.owner}</Chip>}
          </li>
        ))}
      </ul>
      <Button variant="ghost" onClick={() => setAll(!all)}>{all ? `Show only the ${open.length} left` : `Show all ${data.total}, including the ${data.done} done`}</Button>
    </Panel>
  )
}
